enum Role {
    BUYER = 1,
    SUPPLIER = 2,
    ADMINISTRATOR = 5,
}

export default Role;
